import { render, staticRenderFns } from "./ecologyDomain.vue?vue&type=template&id=4c8dba2d&scoped=true&"
import script from "./ecologyDomain.vue?vue&type=script&lang=js&"
export * from "./ecologyDomain.vue?vue&type=script&lang=js&"
import style0 from "./ecologyDomain.vue?vue&type=style&index=0&id=4c8dba2d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8dba2d",
  null
  
)

export default component.exports